export default function(ac, app) {
    var dashboard = app.getEntity('dashboard');
    dashboard
        .listView()
        .fields([
            ac.field('sifra_naloga').label('Šifra naloga'),
            ac.field('pacijent'),
            ac
                .field('ordinacija', 'reference')
                .targetEntity(app.getEntity('Ordinacija'))
                .targetField(ac.field('naziv'))
        ])
        .listActions(['edit']);

    return dashboard;
}



// WEBPACK FOOTER //
// ./app/components/dashboard/config.js